import humanizeString from 'humanize-string'
import React, { FC } from 'react'

import { HomeOperationsReadinessStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter, FiltersSharedProps } from '@avantstay/backoffice-core'

interface OperationStatusFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const OperationStatusFilter: FC<OperationStatusFilterProps> = ({
  initialValue,
  onChange,
}) => {
  const statusFilterOptions = Object.values(HomeOperationsReadinessStatus).map(statusOption => ({
    id: statusOption,
    label: humanizeString(statusOption),
    value: statusOption,
  }))

  return (
    <div style={{ minWidth: '120px', paddingTop: '8px' }}>
      <CheckboxBasedFilter
        options={statusFilterOptions}
        onChange={onChange}
        initialValue={initialValue}
        title="Status"
      />
    </div>
  )
}
